import React from 'react';

const SurveyPage = ({ className, renderQuestionGroups }) => {
  return (
    <div className={className}>
      <div className="questionGroups clear">
        { renderQuestionGroups() }
      </div>
    </div>
  );
};

export default SurveyPage;
